<div class="pt-3 pl-4 w-full">
  <span>
    <label [for]="'pdTextArea_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId"> {{projectDescriptor.label}} @if (projectDescriptor.help) {
      <i class="pi pi-question-circle" [pTooltip]="projectDescriptor.help" style="font-size: 1rem"></i>
    }</label>
    <textarea rows="6" [pTooltip]="projectDescriptor.help" tooltipPosition="top"
      class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border rounded-border appearance-none outline-none focus:border-primary w-full"
    type="text" [id]="'pdTextArea_'+descriptorCategory().uniqueId+'_'+projectDescriptor.uniqueId" pInputTextarea [(ngModel)]="holder.value"></textarea>
  </span>
</div>
